import { Controller } from "@hotwired/stimulus"

// Cookie consent banner. Advertising cookies stay denied (Consent Mode default,
// set in the layout head) until the visitor accepts here. The choice is stored
// so the banner shows only once; clearing the site's cookies brings it back.
export default class extends Controller {
  connect() {
    let choice = null
    try { choice = localStorage.getItem("cookie_consent") } catch {}
    if (choice) { this.element.remove(); return }
    this.element.classList.remove("hidden")
  }

  accept() {
    this.store("granted")
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", {
        ad_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted"
      })
    }
    this.element.remove()
  }

  refuse() {
    this.store("denied")
    this.element.remove()
  }

  store(value) {
    try { localStorage.setItem("cookie_consent", value) } catch {}
  }
}
